/* eslint-disable */

import React, { useState, useEffect, useRef } from 'react';
import {
  InputLabel,
  Button,
  Typography,
  Box,
  InputBase,
  InputAdornment,
  TextField,
  Popover,
  Paper,
  Divider,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
} from '@material-ui/core';
import { Formik, Form, FastField, Field } from 'formik';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search-Icon.svg';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import {
  COST_OF_LIVING_TYPE,
  FACILITY_TYPES,
  OTHER_TRANSPORTATION_TYPES,
  PUBLIC_TRANSPORTATION_TYPES,
  SCHOOL_TYPES,
  entityEnum,
} from '../../../../constants/globalConstants';
import useCommunityList from '../../../../hooks/useCommunityList';
import useClub from '../../../../hooks/useClub';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import '../../Main.style.css';
import { get } from 'lodash';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon color="primary" fontSize="small" />;

const CommunityListSearch = ({
  searchedText,
  clearSearch,
  handleFilterClose,
  handleSearchChange,
  open,
  anchorEl,
  handleFilterClick,
  intialWhereValue,
  currentWhere,
  communityList,
  tabValue,
  fillCommunityList,
  allCommunities,
  setWhere,
}) => {
  const {
    getAllCommunities,
    getAmenityCategories,
    getHealthFacilityTypes,
    getAllStates,
  } = useCommunityList();

  const { getClubCategories } = useClub();

  const [resultCount, setResultCount] = useState(0);
  const [seeResultText, setSeeResultText] = useState('See Results');
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const key = 'iFrasCwdJh';
  const formikRef = useRef();
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);
  const [amenitiesCategoryMain, setAmenityCategoriesMain] = useState([]);
  const [facilityTypeOptions, setFacilityTypeOptions] = useState([]);
  const [clubsCategoryMain, setClubsCategoriesMain] = useState([]);

  const getTotal = async (values) => {
    const totalCount =
      values?.states?.length +
      ((values?.minPopulation > -1 && 1) || 0) +
      ((values?.maxPopulation > -1 && 1) || 0) +
      values?.amenitiesType?.length +
      values?.costOfLivingType?.length +
      values?.publicTransType?.length +
      ((values?.dedicatedWalkingPaths === true && 1) + 0) +
      ((values?.dedicatedBikingPaths === true && 1) + 0) +
      ((values?.localAirport === true && 1) + 0) +
      ((values?.regionalAirport === true && 1) + 0) +
      ((values?.publicType === true && 1) + 0) +
      ((values?.privateType === true && 1) + 0) +
      ((values?.faithBasedPrivate === true && 1) + 0) +
      ((values?.specialNeedsPrivate === true && 1) + 0) +
      ((values?.publicTechnicalJuniorCollege === true && 1) + 0) +
      ((values?.privateTechnicalJuniorCollege === true && 1) + 0) +
      ((values?.publicFourYearCollegeUniversity === true && 1) + 0) +
      ((values?.privatecFourYearCollegeUniversity === true && 1) + 0) +
      ((values?.homeschoolResourceGroups === true && 1) + 0) +
      ((values?.charter === true && 1) + 0) +
      values?.facilityType?.length +
      values?.clubsType?.length;
    setTotal(totalCount);
    let data = null;
    if (totalCount) {
      data = await getAllCommunities({
        ...values,
        tab: tabValue,
        states: values?.states?.map((s) => s?.id),
        getResultCount: true,
        searchText: searchedText,
      });
      setResultCount(data?.count || 0);
    } else {
      setResultCount(0);
    }
    setSeeResultText(`See  ${totalCount > 0 ? `[${data?.count}]` : ``} Results`);
  };
  const loadAllFacilityTypes = async () => {
    const facilityType = await getHealthFacilityTypes();
    setFacilityTypeOptions(facilityType?.data);
  };
  const loadAmenityCategories = async () => {
    const amenityCatArr = await getAmenityCategories();
    setAmenityCategoriesMain(amenityCatArr.usersResult);
  };
  const loadClubCategories = async () => {
    const clubCatArr = await getClubCategories();
    setClubsCategoriesMain(clubCatArr.usersResult);
  };
  /* useEffect(() => {
    setSeeResultText(`See  ${total > 0 ? `[${resultCount}]` : ``} Results`);
  }, [resultCount]); */

  const loadAllStates = async () => {
    try {
      const response = await getAllStates();
      if (response?.status && response?.data) {
        LocationOptionsBox = response.data.map((state) => ({
          stateName: state.stateName,
          id: state.id,
        }));
      } else {
        LocationOptionsBox = [];
      }
    } catch (error) {
      LocationOptionsBox = [];
    }
  };

  useEffect(() => {
    loadAllStates();
    loadAmenityCategories();
    loadAllFacilityTypes();
    loadClubCategories();
  }, [allCommunities]);

  // Filters are now persisted via URL — no reset on tab change
  // useEffect(() => {
  //   if (formikRef.current) {
  //     formikRef.current.resetForm();
  //   }
  // }, [tabValue]);

  const getCount = (values) => {
    getTotal(values);
    return (
      <Box className="FilterCount" component="span">
        {total > 0 ? `(${total})` : ''}
      </Box>
    );
  };
  return (
    <>
      {' '}
      <Formik
        initialValues={currentWhere || intialWhereValue}
        enableReinitialize
        // validationSchema={SetPasswordSchema}
        onSubmit={async (values) => {
          setWhere(values);
          await fillCommunityList({ ...values, states: values?.states?.map((s) => s?.id) });
          handleFilterClose();
          // loadAllStates();
        }}
        innerRef={formikRef}
      >
        {({ values, setFieldTouched, setFieldValue, submitForm, resetForm }) => (
          <>
            <Box className="SearchBoxContainer" mb={0}>
              <TextField
                className="SearchBox"
                value={searchedText}
                as={InputBase}
                onChange={handleSearchChange}
                variant="outlined"
                type="text"
                placeholder="Search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className="GreenColor" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end" onClick={clearSearch}>
                      {searchedText !== '' && <CloseIcon className="GreenColor" />}
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                className="SearchButton"
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleFilterClick}
                startIcon={<FilterListIcon color="primary" />}
                variant="outlined"
              >
                Filters {getCount(values)}
              </Button>
            </Box>
            <Popover
              id="long-menu"
              open={open}
              anchorEl={anchorEl}
              onClose={handleFilterClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              className="MobileFilter"
            >
              <Paper className="CommonFilterBox AmenityFilters">
                <Box className="FilterHeader">
                  <Typography className="FilterBackButton" variant="h4" onClick={handleFilterClose}>
                    <ArrowBackIcon color="primary" className="BackButtonArrow" />
                    Community Filters
                  </Typography>
                </Box>
                <Box className="FilterBody">
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Location
                    </Typography>
                    <Box className="FilterTagContent FilterDropdownContent">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        State
                      </InputLabel>
                      <Box className="AutocompleteBox">
                        <Box className="CommonAutocomplete">
                          <Autocomplete
                            className="CommonAutocomplete"
                            multiple
                            name="states"
                            id="checkboxes-tags-demo"
                            options={LocationOptionsBox}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.stateName}
                            value={values.states}
                            getOptionSelected={(option, value) => option?.id === value?.id}
                            renderOption={(option, { selected }) => (
                              <React.Fragment>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 0 }}
                                  checked={selected}
                                />
                                {option.stateName}
                              </React.Fragment>
                            )}
                            onChange={(e, value) => setFieldValue('states', value)}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="" label="" variant="outlined" />
                            )}
                            popupIcon={<KeyboardArrowDownIcon />}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Residents
                    </Typography>
                    <Box className="FilterTagContent FilterDropdownContent">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        Population
                      </InputLabel>
                      <Box className="AutocompleteBox">
                        <Box className="HalfwidthBox">
                          <Autocomplete
                            className="CommonAutocomplete"
                            id="minPopulation"
                            name="minPopulation"
                            options={PopulationOptionsBoxMin}
                            getOptionLabel={(option) => option?.label}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="No Min"
                                label=""
                                variant="outlined"
                              />
                            )}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={PopulationOptionsBoxMin?.find(
                              (p) => p?.value === values.minPopulation,
                            )}
                            onChange={(e, data) => setFieldValue('minPopulation', data?.value)}
                          />
                        </Box>
                        <Box className="DashIcon">
                          <Typography variant="body2">-</Typography>
                        </Box>
                        <Box className="HalfwidthBox">
                          <Autocomplete
                            className="CommonAutocomplete"
                            id="maxPopulation"
                            name="maxPopulation"
                            options={PopulationOptionsBoxMax?.map((p) =>
                              values?.minPopulation > p?.value && p?.value !== -1
                                ? { ...p, disabled: true }
                                : p,
                            )}
                            getOptionDisabled={(option) => option.disabled}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="No Max"
                                label=""
                                variant="outlined"
                              />
                            )}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={PopulationOptionsBoxMax?.find(
                              (p) => p?.value === values.maxPopulation,
                            )}
                            onChange={(e, data) => setFieldValue('maxPopulation', data?.value)}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Amenities
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    {amenitiesCategoryMain?.map((amenitiesCategory) => (
                      <Box key={amenitiesCategory?.id} className="FilterTagContent FilterTagInner">
                        <InputLabel className="InputLabelFld">
                          {amenitiesCategory?.amenityCategoryName}
                        </InputLabel>
                        {amenitiesCategory?.amenityType?.map((amenitiesType) => (
                          <Button
                            key={amenitiesCategory?.id + amenitiesType?.id}
                            className={`FilterTag ${
                              values?.amenitiesType?.includes(amenitiesType?.id) ? 'Selected' : ''
                            }`}
                            onClick={() => {
                              setFieldValue(
                                'amenitiesType',
                                values?.amenitiesType &&
                                  values?.amenitiesType?.includes(amenitiesType?.id)
                                  ? values?.amenitiesType.filter(
                                      (selected) => selected !== amenitiesType?.id,
                                    )
                                  : [...(values?.amenitiesType ?? []), amenitiesType?.id],
                              );
                              /* setTimeout(() => {
                                setFieldTouched('amenitiesType');
                              }, 2000); */
                              // handleFilterClick1(facilityType);
                            }}
                          >
                            {amenitiesType?.amenityTypeName}
                          </Button>
                        ))}
                      </Box>
                    ))}
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Cost of Living
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    <Box className="FilterTagContent FilterTagInner">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        Cost of Living
                      </InputLabel>
                      <FormControl component="fieldset" className="">
                        <FormGroup>
                          {COST_OF_LIVING_TYPE?.map((costOfLivingType) => (
                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  color="primary"
                                  name="costOfLivingType"
                                  value={costOfLivingType}
                                  checked={values?.costOfLivingType?.some(
                                    (c) => c === costOfLivingType,
                                  )}
                                />
                              }
                              label={costOfLivingType}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Transportation
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    <Box className="FilterTagContent FilterTagInner">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        Public Transportation
                      </InputLabel>
                      <FormControl component="fieldset" className="">
                        <FormGroup>
                          {PUBLIC_TRANSPORTATION_TYPES?.map((publicTransType) => (
                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  color="primary"
                                  name="publicTransType"
                                  value={publicTransType?.key}
                                  checked={values?.publicTransType?.some(
                                    (c) => c === publicTransType?.key,
                                  )}
                                />
                              }
                              label={publicTransType?.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Box>
                    <Box className="FilterTagContent FilterTagInner">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        Other Transportation
                      </InputLabel>
                      <FormControl component="fieldset" className="">
                        <FormGroup>
                          {OTHER_TRANSPORTATION_TYPES?.map((otherTransType) => (
                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  color="primary"
                                  name={otherTransType?.key}
                                  value={otherTransType?.key}
                                  checked={values[otherTransType?.key]}
                                />
                              }
                              label={otherTransType?.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Education
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    <Box className="FilterTagContent FilterTagInner">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        School Types
                      </InputLabel>
                      <FormControl component="fieldset" className="">
                        <FormGroup>
                          {SCHOOL_TYPES?.map((schoolType) => (
                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  color="primary"
                                  name={schoolType?.key}
                                  value={schoolType?.key}
                                  checked={values[schoolType?.key]}
                                />
                              }
                              label={schoolType?.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Healthcare
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    <Box className="FilterTagContent FilterTagInner">
                      <InputLabel className="InputLabelFld" htmlFor="email">
                        Healthcare Facilities
                      </InputLabel>
                      {facilityTypeOptions?.map((data) => (
                        <Button
                          key={data.id}
                          className={`FilterTag ${
                            values?.facilityType.includes(data.id) ? 'Selected' : ''
                          }`}
                          onClick={() => {
                            setFieldValue(
                              'facilityType',
                              values?.facilityType.includes(data.id)
                                ? values?.facilityType.filter((selected) => selected !== data.id)
                                : [...values?.facilityType, data.id],
                            );
                            setFieldTouched('facilityType');
                            setFieldTouched('facilityType');
                            setTimeout(() => {
                              setFieldTouched('facilityType');
                            }, 2000);
                            // handleFilterClick1(facilityType);
                          }}
                        >
                          {data.facilityType}
                        </Button>
                      ))}
                      {/* <Button className="FilterTag">Assisted Living Facility</Button>
                    <Button className="FilterTag">Behavioral Health Facility</Button>
                    <Button className="FilterTag">Home Healthcare</Button>
                    <Button className="FilterTag">Hospice Services</Button>
                    <Button className="FilterTag">Hospital - General Acute Care</Button>
                    <Button className="FilterTag">Hospital - Specialty Care</Button>
                    <Button className="FilterTag">Long Term Care Facility</Button>
                    <Button className="FilterTag">Outpatient Specialty Care Facility</Button> */}
                    </Box>
                  </Box>
                  <Box className="FilterTagBox">
                    <Typography variant="h3" className="LightgreyColor FilterTagHeading">
                      Clubs & Connections
                    </Typography>
                    <Typography component="div" variant="caption" className="FilterTagSubHeading">
                      Only represented communities with this content will show in results.
                    </Typography>
                    {clubsCategoryMain?.map((clubsCategory) => (
                      <Box key={clubsCategory?.id} className="FilterTagContent FilterTagInner">
                        <InputLabel className="InputLabelFld">
                          {clubsCategory?.clubCategoryName}
                        </InputLabel>
                        {clubsCategory?.clubType?.map((clubsType) => (
                          <Button
                            key={clubsCategory?.id + clubsType?.id}
                            className={`FilterTag ${
                              values?.clubsType?.includes(clubsType?.id) ? 'Selected' : ''
                            }`}
                            onClick={() => {
                              setFieldValue(
                                'clubsType',
                                values?.clubsType && values?.clubsType?.includes(clubsType?.id)
                                  ? values?.clubsType.filter(
                                      (selected) => selected !== clubsType?.id,
                                    )
                                  : [...(values?.clubsType ?? []), clubsType?.id],
                              );
                            }}
                          >
                            {clubsType?.clubTypeName}
                          </Button>
                        ))}
                      </Box>
                    ))}
                  </Box>
                </Box>
                <Box className="FilterFooter">
                  <Divider />
                  <Box className="FilterAction">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={async () => {
                        resetForm();
                        // loadAllStates();
                        // submitForm();
                        setWhere(intialWhereValue);
                        await fillCommunityList({
                          ...intialWhereValue,
                          states: intialWhereValue?.states?.map((s) => s?.id),
                        });
                      }}
                    >
                      Reset Filters
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        submitForm();
                        // loadAllStates();
                      }}
                      color="primary"
                      size="small"
                    >
                      {seeResultText}
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Popover>
          </>
        )}
      </Formik>
    </>
  );
};

let LocationOptionsBox = [
  { stateName: 'Alabama', id: 1 },
  { stateName: 'Georgia', id: 0 },
];
const PopulationOptionsBoxMin = [
  { label: 'No Min', value: -1 },
  { label: '5,000', value: 5000 },
  { label: '50,000', value: 50000 },
  { label: '100,000', value: 100000 },
  { label: '250,000', value: 250000 },
  { label: '500,000', value: 500000 },
];
const PopulationOptionsBoxMax = [
  { label: 'No Max', value: -1 },
  { label: '5,000', value: 5000 },
  { label: '50,000', value: 50000 },
  { label: '100,000', value: 100000 },
  { label: '250,000', value: 250000 },
  { label: '500,000', value: 500000 },
];

export default CommunityListSearch;
